import * as React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export const PhoneIcon = ({ stroke = 'coolGreyDark', size = 'small' }: IconProps) => {
    const strokeStyles = cn(Styles[stroke], Styles.stroke);

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={IconSizes[size]} height={IconSizes[size]} viewBox="0 0 33 56">
            <defs>
                <filter id="cw68fb6woa">
                    <feColorMatrix
                        in="SourceGraphic"
                        values="0 0 0 0 0.615686 0 0 0 0 0.698039 0 0 0 0 0.768627 0 0 0 1.000000 0"
                    />
                </filter>
            </defs>
            <g fill="none" fillRule="evenodd">
                <g>
                    <g>
                        <g filter="url(#cw68fb6woa)" transform="translate(-367 -196) translate(16 148) translate(0 48)">
                            <g>
                                <path
                                    className={strokeStyles}
                                    fill="#35373D"
                                    fillRule="nonzero"
                                    d="M27 0c3.314 0 6 2.686 6 6v44c0 3.314-2.686 6-6 6H6c-3.314 0-6-2.686-6-6V6c0-3.314 2.686-6 6-6h21zm0 2H6C3.858 2 2.109 3.684 2.005 5.8L2 6v44c0 2.142 1.684 3.891 3.8 3.995L6 54h21c2.142 0 3.891-1.684 3.995-3.8L31 50V6c0-2.142-1.684-3.891-3.8-3.995L27 2zM16.5 43c1.933 0 3.5 1.567 3.5 3.5S18.433 50 16.5 50 13 48.433 13 46.5s1.567-3.5 3.5-3.5zm0 2c-.828 0-1.5.672-1.5 1.5s.672 1.5 1.5 1.5 1.5-.672 1.5-1.5-.672-1.5-1.5-1.5zM21 6c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L21 8h-4.5c-.552 0-1-.448-1-1 0-.513.386-.936.883-.993L16.5 6H21zm-8 0c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L13 8h-1.5c-.552 0-1-.448-1-1 0-.513.386-.936.883-.993L11.5 6H13z"
                                    transform="translate(351)"
                                />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};
